import { useEffect, useState } from "react";
import api from "../../lib/api";
import { Input } from "../ui/input";
import { Label } from "../ui/label";
import { Textarea } from "../ui/textarea";
import { Switch } from "../ui/switch";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "../ui/select";
import { CLASSIFICATIONS } from "./IncidentSummaryTable";

const F = ({ label, children }) => <div><Label className="text-xs">{label}</Label>{children}</div>;

export function IncidentSummaryFields({ r, set }) {
  const [users, setUsers] = useState([]);
  useEffect(() => {
    api.get("/incidents/owners").then(({ data }) => setUsers(data || [])).catch(() => {});
  }, []);
  return (
    <div className="border border-border p-3 space-y-3" data-testid="incident-summary-fields">
      <h4 className="font-semibold text-sm">Classification &amp; Disposition</h4>
      <div className="grid grid-cols-2 gap-3">
        <F label="Classification">
          <Select value={r.classification || "none"} onValueChange={(v) => set("classification", v === "none" ? "" : v)}>
            <SelectTrigger className="rounded-none" data-testid="incident-edit-classification"><SelectValue /></SelectTrigger>
            <SelectContent>
              <SelectItem value="none">Unclassified</SelectItem>
              {CLASSIFICATIONS.map(([k, l]) => <SelectItem key={k} value={k}>{l}</SelectItem>)}
            </SelectContent>
          </Select>
        </F>
        <F label="Initial triage date"><Input type="date" value={r.triage_date || ""} onChange={(e) => set("triage_date", e.target.value)} className="rounded-none" data-testid="incident-edit-triage-date" /></F>
        <F label="Standard"><Input value={r.standard_id || ""} onChange={(e) => set("standard_id", e.target.value)} placeholder="e.g. CIP-004-7" className="rounded-none" data-testid="incident-edit-standard" /></F>
        <F label="Requirement"><Input value={r.requirement || ""} onChange={(e) => set("requirement", e.target.value)} placeholder="e.g. R4.3" className="rounded-none" data-testid="incident-edit-requirement" /></F>
        <F label="Owner (gets deadline reminders)">
          <Select value={r.owner_id || "none"} onValueChange={(v) => set("owner_id", v === "none" ? "" : v)}>
            <SelectTrigger className="rounded-none" data-testid="incident-edit-owner"><SelectValue placeholder={r.owner || "Unassigned"} /></SelectTrigger>
            <SelectContent>
              <SelectItem value="none">{!r.owner_id && r.owner ? `${r.owner} (not linked to a user)` : "Unassigned"}</SelectItem>
              {users.map((u) => <SelectItem key={u.id} value={u.id}>{u.name || u.email}</SelectItem>)}
            </SelectContent>
          </Select>
        </F>
        <F label="Resolution date"><Input type="date" value={r.resolution_date || ""} onChange={(e) => set("resolution_date", e.target.value)} className="rounded-none" data-testid="incident-edit-resolution-date" /></F>
      </div>
      <F label="Initial review summary"><Textarea value={r.initial_review || ""} onChange={(e) => set("initial_review", e.target.value)} rows={2} className="rounded-none" data-testid="incident-edit-initial-review" /></F>
      <div className="flex items-center gap-4 flex-wrap">
        <div className="flex items-center gap-2">
          <Switch checked={!!r.self_report_filed} onCheckedChange={(v) => set("self_report_filed", v)} data-testid="incident-edit-self-report" />
          <Label className="text-xs">Self-report filed</Label>
        </div>
        {r.self_report_filed && <Input type="date" value={r.self_report_date || ""} onChange={(e) => set("self_report_date", e.target.value)} className="rounded-none w-44" data-testid="incident-edit-self-report-date" />}
      </div>
      <F label="Final disposition"><Textarea value={r.final_disposition || ""} onChange={(e) => set("final_disposition", e.target.value)} rows={2} className="rounded-none" data-testid="incident-edit-final-disposition" placeholder="Outcome, mitigation completed, regulator response…" /></F>
    </div>
  );
}
